<template>
<div class="page_toutiao page_dingzhi_works">
	<!-- 作品展 -->
	<div class="title_wrap">
		<div class="title">定制代表作</div>
	</div>
	<!-- 列表 -->
	<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
		<div class="list">
			<div class="item" v-for="item in dataList" :key="item.id">
				<div class="item_title">{{ item.title }}</div>
				<div class="item_title" v-if="item.cate">{{'【'+ item.cate +'】'}}</div>
				<div class="item_tu more" v-if="item.album && item.album.length != 0">
					<div class="tu_wrap" v-for="(image,index) in item.album" :key="index" @click="zhanshitupian(item.album,index)">
						<van-image class="tu" fit="cover" :src="imageUrl+image" :show-error="false" :show-loading="false"/>
					</div>
				</div>
			</div>
			<!-- <div class="item">
				<div class="item_title">手工干泡茶席纯铜锤纹茶器</div>
				<div class="item_title">【雨过天晴-系列】</div>
				<div class="item_tu more">
					<div class="tu_wrap">
						<van-image class="tu" fit="cover" :src="publicPath+'statics/images/temp/zhuanti.png'" :show-error="false" :show-loading="false"/>
					</div>
					<div class="tu_wrap">
						<van-image class="tu" fit="cover" :src="publicPath+'statics/images/temp/zhuanti.png'" :show-error="false" :show-loading="false"/>
					</div>
				</div>
			</div> -->
		</div>
	</van-list>
	<!-- 大图预览 -->
    <van-image-preview v-model="bigTuShow" :start-position="bigTuIndex" :images="bigTuImgArr" @change="bigTuChange"></van-image-preview>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
            pages: {
                page: 1,
                size: 10
            },
            loading: true,
			finished: false,
			dataList: [], // 列表
			bigTuShow: false,
			bigTuIndex: 0,
			bigTuImgArr: null,
			tra_uuid: this.$route.query.tra_uuid
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '作品展'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
				}
				this.getData()
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
			this.token = this.$store.getters.token
			this.getData()
        }
		
    },
    methods: {
        // 作品展
        getData() {	
            var params = {
				token: this.token,
				page: this.pages.page,
				size: this.pages.size,
				tra_uuid: this.tra_uuid
			}
			this.$api.dingzhi.trawork(params).then(res=>{
				if(res.code == 200){
					var list = res.result.list
					if(list.length != 0){
						for(var i in list){
							this.dataList.push(list[i])
						}
					}else{
						this.finished = true
						this.loading = true
					}
				}else{
					this.$toast(res.result.message)
					this.finished = true
					this.loading = true
				}
				this.pages.page++
				this.loading = false
			})
        },
		// 展开大图 
		zhanshitupian(arr,index) {
			for(let i in arr){
				arr[i] = this.imageUrl+arr[i];
			};
			this.bigTuImgArr = arr;
			this.bigTuIndex = index;
			this.bigTuShow = true;
        },
		// 切换大图
        bigTuChange(index) {
            this.bigTuIndex = index
        },
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
